import { always, cond, equals, identity, T } from 'ramda'
import ajax from './ajax'

const mapTypeToCode = cond([
  [equals('AIRPORT'), always('A')],
  [equals('CITY'), always('C')],
  [equals('HOTEL'), always('H')],
  [equals('POI'), always('P')],
  [T, identity]
])

// swagger for feedback call api http://ny-htlindex-001:8080/typeahead/index/swagger-ui.html#/feedback-controller/typeaheadFeedbackWithSelectedPositionUsingGET
const makeFeedbackAjaxCall = (url) =>
  ({ entered, id, itemName, displayName, type, selectedPosition }) => ajax({
    url: `${url}/${id}/${encodeURIComponent(entered)}/${encodeURIComponent(itemName || displayName)}/${selectedPosition}`,
    type: 'GET',
    data: {
      language: 'en',
      locale: 'en-US',
      placeType: mapTypeToCode(type)
    }
  })

export { makeFeedbackAjaxCall as default }
